import { Colors } from '@blueprintjs/core';
import styled from 'styled-components';

export const WorkflowInnerContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  overflow: auto;
  padding: 20px;
`;

export const WorkflowSuccessContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 20px;
`;

export const WorkflowErrorContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 20px;
  background-color: ${Colors.RED5};
`;

export const WorkflowFooter = styled.div`
  padding: 20px;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
`;

export const WorkflowHeaderContainer = styled.div<{
  $videoUploadError?: boolean;
}>`
  padding: 20px;
  background-color: ${(props) =>
    props.$videoUploadError ? Colors.RED5 : Colors.LIGHT_GRAY1};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
`;

export const WorkflowBreadcrumbsContainer = styled.div`
  display: flex;
  justify-content: center;
`;
